module.exports = __webpack_public_path__ + "static/media/High-Jinks.59c3345f.otf";